export class PasswordReset {
  public userName: string;
  public password: string;
  public phonetic: string;
}
